export default "__VITE_ASSET__3007a2b9__"